// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://citrussheriff-vendor.aclarian.com',
  appName: "Citrus County Sheriff's Office | VendorV2",
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub0b3f617c2c37b58ae06959ab54964c72',
  datadogApplicationId: '475b172e-fcc1-448b-bddf-400a97f969d0',
  datadogService: 'invoicing_citrus_county_sheriff',
  ApiKey: 'Wq9@aBnC3#Yt6D%1!',
  env: 'PROD',
  version: packageInfo.version,
};
